interface FiltersProps {
}
export default function Filters(props: FiltersProps) {

  return <div style={{ display: 'flex', gap: '20px' }}>
    Add any filter here for page
  </div>
} 